/**
 * PC 客户端启动携带参数
 */
import store from '../store/store';
import { _change_ds_modal } from '../store/Action';

if (window?.eleEvents?.events) {
  window.eleEvents.events["onStartupParams"] = (data) => {
    // 打开用户主页
    if (data?.dsid) {
      setTimeout(() => {
        _change_ds_modal({ dsid: data.dsid, jnid: data.jnid || "", ehot: data.ehot || "" });
      }, 1000)
    }
    // 定位指定品类
    else if (data?.jnid) {
      setTimeout(() => {
        store.dispatch({type: "change_jnid", data: {jnid: data.jnid}});
      }, 1000)
    }
    // 进入房间
    if (data?.roomid) {
      window.location.href = `/room?roomid=${data.roomid}`
    }
    // 网吧环境，获取 sid 参数
    if (data?.sid) {
      store.dispatch({type: "wb_sid", data: {wb_sid: data.sid}});
    }
  }
}
